import type { DevEnv } from "@p0security/shared/types/environment";

import type { AwsPartition } from "../util.ts";
import type { AwsPolicyOptions } from "./policies.ts";
import { roleInstallCommands, roleTerraform } from "./shared.ts";

export const accessAnalyzerName = "P0AccessAnalyzer";

const accessAnalyzerCommand = `ANALYZERS_JSON=$(aws accessanalyzer list-analyzers)
ANALYZER_COUNT=$(echo $ANALYZERS_JSON | jq -r '.analyzers | length')
if [ "$ANALYZER_COUNT" -gt 0 ]; then
  ARN=$(echo $ANALYZERS_JSON | jq -r '.analyzers[0].arn')
else
  ARN=$(aws accessanalyzer create-analyzer --type ACCOUNT_UNUSED_ACCESS --analyzer-name ${accessAnalyzerName} --configuration '{"unusedAccess": {"unusedAccessAge": 90}}' --query "arn" --output text)
fi
echo $ARN
`;

const accessAnalyzerTerraform = `resource "aws_accessanalyzer_analyzer" "p0_aws_access_analyzer" {
  analyzer_name = "${accessAnalyzerName}"
  type          = "ACCOUNT_UNUSED_ACCESS"
  configuration {
    unused_access {
      unused_access_age = 90
    }
  }
}

output "access_analyzer_arn" {
  value       = aws_accessanalyzer_analyzer.p0_aws_access_analyzer.arn
  description = "ARN of the Access Analyzer for this account. Use this value when configuring P0 IAM Assessment."
}`;

export const iamAssessmentInstallCommands = (
  context: DevEnv,
  options: AwsPolicyOptions,
  args: {
    gcloudServiceAccountId: string;
    awsAccountId: string;
    awsPartition: AwsPartition;
  }
) => {
  const roleSetupCommands = roleInstallCommands(
    "iam-assessment",
    context,
    options,
    args
  );

  return `${roleSetupCommands} \\
  && \\
${accessAnalyzerCommand}`;
};

// TODO: Test terraform prior to making this install public
export const iamAssessmentTerraform = (
  context: DevEnv,
  options: AwsPolicyOptions,
  gcloudServiceAccountId: string,
  awsPartition: AwsPartition
) => {
  const roleSetupTerraform = roleTerraform(
    "iam-assessment",
    context,
    options,
    gcloudServiceAccountId,
    awsPartition
  );
  return `${roleSetupTerraform}

${accessAnalyzerTerraform}`;
};
